import { render, staticRenderFns } from "./GroupConfiguration.vue?vue&type=template&id=f475e374&"
import script from "./GroupConfiguration.vue?vue&type=script&lang=js&"
export * from "./GroupConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./GroupConfiguration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports